import { render } from "./BaSummary.vue?vue&type=template&id=2cf13182&scoped=true&ts=true"
import script from "./BaSummary.vue?vue&type=script&lang=ts"
export * from "./BaSummary.vue?vue&type=script&lang=ts"

import "./BaSummary.vue?vue&type=style&index=0&id=2cf13182&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf13182"]])

export default __exports__